<template>
  <div class="popup_in flex flex--column">
    <div class="pop-confirm popup">
      <div class="ic-ok"><okSvg /></div>
      <div v-if="isBlockingApp" class="title">תור חוסם נקבע בהצלחה</div>
      <div v-else class="title">
        התור נקבע בהצלחה<br />
        נשלח SMS עדכון למטופל
      </div>
      <div v-if="!isBlockingApp" class="title--32 ft--300">
        באפשרותך להוסיף תור נוסף לאותו מטופל עם הפרטים הקיימים
      </div>
      <div class="pop-confirm-btns flex flex--content--center">
        <a class="link_blue" @click.prevent="addNewApp">קביעת תור נוסף</a>
        <a class="bt_blue" @click.prevent="goHome">סגור</a>
      </div>
    </div>
  </div>
</template>

<script>
import okSvg from "../../assets/img/svg/ok.svg";
import { mapState, mapMutations, mapGetters } from "vuex";
import { getHash } from "../../utilities/hash.js";

export default {
  name: "ConfirmNewApp",
  props: {
    isBlockingApp: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations(["SET_APP_TIME_EDIT"]),
    async goHome() {
      const date = this.$moment(this.appTimeEdit.date, "DD/MM/YYYY").format(
        "MM/DD/YYYY"
      );
      // await this.SET_IS_CHANGE_APP(true);
      await this.SET_APP_TIME_EDIT(null);
      const hash = getHash({
        date: this.$moment(date, "MM/DD/YYYY").format("YYYY-MM-DD"),
        view: "day"
      });
      this.$router.push("/dashboard#" + hash);
      this.$emit("close");
    },
    addNewApp() {
      this.$emit("close");
      this.$router.push(
        "/app-add?passoport=" + this.Appoitments.patient.id_num
      );
    }
  },
  computed: {
    ...mapState(["Appoitments"]),
    ...mapGetters(["appTimeEdit"])
  },
  components: {
    okSvg
  }
};
</script>

<style scoped></style>
